import {coreApi} from './core'

export const terminalService = {
    getAll: async () => coreApi.get(`terminal`),
    getById: async (id) => coreApi.get(`terminal?id=${id}`),
    create: async (data) => coreApi.post(`terminal`, data),
    update: async (data) => coreApi.put(`terminal`, data),
    delete: async (id) => coreApi.delete(`terminal/${id}`),
    paginate: async (offset) => coreApi.get(`/terminal/${offset}`),
}